var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCursosExclusivos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5C6CDAE8-8F46-4FE8-B7A7-5B3744617808") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-24.000000, -631.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-cursos-excusivos",
    transform: "translate(0.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9285365,9.05641887 C22.9264832,9.05218062 22.9247233,9.04779623 22.9226211,9.04355798 L19.9892702,3.19759977 C19.9874613,3.19399483 19.9853591,3.19063346 19.9835013,3.18707722 C19.852285,2.9375564 19.5963544,2.79365079 19.3333838,2.79365079 L4.66653165,2.79365079 C4.3982323,2.79365079 4.14655499,2.93955374 4.01641416,3.18707722 C4.0145564,3.19063346 4.0124542,3.19404354 4.01064533,3.19759977 L1.07729445,9.04355798 C1.07519225,9.04779623 1.07338338,9.05213191 1.07137895,9.05641887 C0.995601985,9.21440326 1.00004907,9.36581105 1.00004907,9.36581105 C0.998828617,9.53300267 1.05749466,9.70199676 1.16597794,9.83338248 C1.16793348,9.83576954 1.17003568,9.83796174 1.1720401,9.8403488 C1.17257787,9.8409821 1.17311564,9.84156669 1.17365342,9.84219999 C1.17595117,9.84492806 1.17800448,9.84775356 1.18035112,9.85043291 L11.4471037,21.5911135 C11.4483748,21.592575 11.4498903,21.5938416 11.4511614,21.5953031 C11.7408739,21.9213072 12.2553261,21.9252045 12.5487541,21.5953031 C12.5500252,21.5938416 12.5515407,21.5926237 12.5528118,21.5911623 L22.8196133,9.85048163 C22.8219599,9.84780227 22.8240132,9.84492806 22.826311,9.84224871 C22.8268487,9.84161541 22.8273865,9.84103082 22.8279243,9.84039752 C22.9447675,9.70141218 23.0010869,9.53110277 22.9998876,9.36581105 C22.9998876,9.36581105 23.0059757,9.21781335 22.9285365,9.05641887 Z M18.1468143,4.2551647 L16.2747321,7.98609048 L13.4666332,4.2551647 L18.1468143,4.2551647 Z M14.9332842,8.63965771 L9.06658242,8.63965771 L11.9999333,4.74231977 L14.9332842,8.63965771 Z M10.5332823,4.2551647 L7.72518342,7.98609048 L5.8531012,4.2551647 L10.5332823,4.2551647 Z M4.66653165,5.15839891 L6.41331299,8.639609 L2.91975032,8.639609 L4.66653165,5.15839891 Z M3.34483466,10.1011229 L7.09100353,10.1011229 L9.90056907,17.5979522 L3.34483466,10.1011229 Z M11.9998844,19.0222962 L8.65655569,10.1011229 L15.3433109,10.1011229 L11.9998844,19.0222962 Z M14.0992975,17.5979522 L16.9088631,10.1011229 L20.6550319,10.1011229 L14.0992975,17.5979522 Z M17.5865536,8.63965771 L19.3333838,5.15844762 L21.0801652,8.63965771 L17.5865536,8.63965771 Z",
    id: "Shape",
    stroke: "#1717CE",
    strokeWidth: 0.1,
    fill: "#1717CE",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCursosExclusivos);
export default __webpack_public_path__ + "static/media/ic-cursos-exclusivos.efdbb90d08a7a6bc624da3b2534adcd7.svg";
export { ForwardRef as ReactComponent };